import Sidebar from './Sidebar.connect';

export default Sidebar;